/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LoadReductionDto
 */
export interface LoadReductionDto {
    /**
     *
     * @type {Date}
     * @memberof LoadReductionDto
     */
    date?: Date;
    /**
     *
     * @type {string}
     * @memberof LoadReductionDto
     */
    status?: LoadReductionDtoStatusEnum;
}

/**
 * @export
 */
export const LoadReductionDtoStatusEnum = {
    NoLoadReduction: "NoLoadReduction",
    LightLoadReduction: "LightLoadReduction",
    HeavyLoadReduction: "HeavyLoadReduction",
} as const;
export type LoadReductionDtoStatusEnum =
    (typeof LoadReductionDtoStatusEnum)[keyof typeof LoadReductionDtoStatusEnum];

/**
 * Check if a given object implements the LoadReductionDto interface.
 */
export function instanceOfLoadReductionDto(
    value: object,
): value is LoadReductionDto {
    return true;
}

export function LoadReductionDtoFromJSON(json: any): LoadReductionDto {
    return LoadReductionDtoFromJSONTyped(json, false);
}

export function LoadReductionDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): LoadReductionDto {
    if (json == null) {
        return json;
    }
    return {
        date: json["date"] == null ? undefined : new Date(json["date"]),
        status: json["status"] == null ? undefined : json["status"],
    };
}

export function LoadReductionDtoToJSON(value?: LoadReductionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        date: value["date"] == null ? undefined : value["date"].toISOString(),
        status: value["status"],
    };
}
